var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"background-color":"#F4F4F5 !important"},attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }